import React from "react";
import '../RechargeComponent/reviewrecharge.css';

import { connect } from "react-redux";
// import '@fortawesome/fontawesome-free/css/all.min.css';
// import 'bootstrap-css-only/css/bootstrap.min.css';
// import 'mdbreact/dist/css/mdb.css';
// import { MDBInput } from 'mdb-react-ui-kit';
import { store } from "../../redux/store";
import { setShowRecargeSection } from "../../redux/misc-data/misc-data.action";
class ReviewRecharge extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            message: '',
            planTypeList: [],
            selectedPlan: ''
        }
    }
    enterMobileNumber = (e) => {
        e.preventDefault();
        this.setState({
            mobile: e.target.value
        })
    }



    setSelectedAmount = (value) => {
        this.setState({
            amount: value
        })
    }
    enterAmount = (e) => {
        e.preventDefault();
        this.setState({
            amount: e.target.value
        })
    }

    componentDidMount() {
    }
    componentWillUnmount() {
    }
    render() {

        return (

            <div id="rechareview">
                <div class="head">
                    <div class="hright">
                        <button class="close btn" data-toggle="tooltip" title="Close"></button>
                    </div>
                    <h3>Review - Mobile Recharge</h3>
                </div>

                <div class="reviewbox">
                    <div class="reviewcard">
                        <div class="leftreview">
                            <img src="images/airtel.png" alt="Airtel" />
                            <h5>Mobile - Recharge</h5>
                            <p>9898989898</p>
                        </div>

                        <div class="rightreview">
                            <h5>Airtel Mobile</h5>
                            <p>Madhya Pradesh</p>
                        </div>
                        <hr />
                        <div class="leftreview">
                            <i class="ta"></i>
                            <p>Amount debited from:</p>
                            <h5>TA - 123456789012</h5>
                        </div>
                        <hr />

                        <div class="tnramount">
                            <p>Recharge Amount:</p>
                            <h5>₹ 599.00</h5>
                        </div>

                        <div class="tnrsur">
                            <p>Commission:</p>
                            <h5>₹ 10.00</h5>
                        </div>
                        <div class="totalamt">
                            <p>Total Amount:</p>
                            <h5>₹ 589.00</h5>
                        </div>

                    </div>

                    <div class="col-12 col-sm-5">
                        <div class="form-floating mb-3 mt-3">

                            <input type="password" id="txnPin" class="form-control amntxt" maxlength="5"
                                onInput={(e) => e.target.value = e.target.value.slice(0, 5)}
                                onChange={this.enterAmount} required
                                name="txnPin"
                                placeholder="Transaction Pin"

                            ></input>
                           
                            <label for="txnPin">Transaction Pin</label>
                        </div>
                    </div>
                  

                    <div class="col-12">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="checc" />
                            <label class="custom-control-label" for="checc">I agree to the <a href="#">terms and conditions</a></label>
                        </div>
                    </div>
                    <div class="col-12">
                        <button type="button" class="btn btn-primary" id="mobrecharge">Recharge Now</button>
                    </div>
                </div>
            </div>

        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage },
        miscReduce: { phone } }
) => ({
    errorMessage, loginErrorMessage, phone
});

export default connect(mapStateToProps, null)(ReviewRecharge);
